import { emitNativeEvent } from "./nativeEventBus";
import { NATIVE_EVENTS } from "./nativeMethods";

export const registerNativeHandlers = () => {
  window[NATIVE_EVENTS.GOOGLE_SIGN_IN_SUCCESS] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.GOOGLE_SIGN_IN_SUCCESS, { data });
  };
  window[NATIVE_EVENTS.BACK_PRESS] = () => {
    emitNativeEvent(NATIVE_EVENTS.BACK_PRESS);
  };
  window[NATIVE_EVENTS.PERMISSIONS_GRANTED] = () => {
    emitNativeEvent(NATIVE_EVENTS.PERMISSIONS_GRANTED);
  };
  window[NATIVE_EVENTS.PERMISSIONS_DENIED] = () => {
    emitNativeEvent(NATIVE_EVENTS.PERMISSIONS_DENIED);
  };
  window[NATIVE_EVENTS.FCM_TOKEN] = (token) => {
    emitNativeEvent(NATIVE_EVENTS.FCM_TOKEN, { token });
  };
  window[NATIVE_EVENTS.FCM_TRIGGERED] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.FCM_TRIGGERED, { data });
  };
  window[NATIVE_EVENTS.GET_APP_DETAILS_RESULTS] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.GET_APP_DETAILS_RESULTS, { data });
  };
  window[NATIVE_EVENTS.GET_DEVICE_DETAILS_RESULTS] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.GET_DEVICE_DETAILS_RESULTS, { data });
  };
  window[NATIVE_EVENTS.GET_LOCATION_DETAILS_RESULTS] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.GET_LOCATION_DETAILS_RESULTS, { data });
  };
  window[NATIVE_EVENTS.SOURCE_ATTRIBUTION_RESULT] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.SOURCE_ATTRIBUTION_RESULT, { data });
  };

  window[NATIVE_EVENTS.AUTO_READ_PHONE_NUMBER_RESULT] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.AUTO_READ_PHONE_NUMBER_RESULT, data);
  };
  window[NATIVE_EVENTS.AUTO_READ_PHONE_SMS_RESULT] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.AUTO_READ_PHONE_SMS_RESULT, data);
  };
  window[NATIVE_EVENTS.PROMPT_USER_TO_OPEN_SETTINGS] = () => {
    emitNativeEvent(NATIVE_EVENTS.PROMPT_USER_TO_OPEN_SETTINGS);
  };
  window[NATIVE_EVENTS.NETWORK_STATUS_CHANGED] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.NETWORK_STATUS_CHANGED, { data });
  };
  window[NATIVE_EVENTS.GPS_STATUS_CHANGED] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.GPS_STATUS_CHANGED, { data });
  };

  window[NATIVE_EVENTS.BRANCH_TRAFFIC_DATA] = (data) => {
    emitNativeEvent(NATIVE_EVENTS.BRANCH_TRAFFIC_DATA, data);
  };
};
